<div class="w-100 h-100 margin-xxl--right-16">
  <div class="font--xxl-18 color-body-text padding-xxl--left-32">Location Working Hours</div>
  <div class="line margin-xxl--top-24"></div>

  <div class="flex flex-column border--right-bg-gray container-form">
    <p class="font--xxl-13 color-dark-blue description margin-xxl--top-24 padding-xxl--left-32">
      Configure the standard operation hours
    </p>

    <div class="flex flex-column padding-xxl--left-32 padding-xxl--right-32">
      <div
        class="flex justify-content-between align-items-center margin-xxl--bottom-16"
        *ngFor="let workingHour of workingHours; let i = index"
      >
        <div
          class="font--xxl-16 color-body-text margin-xxl--right-32 w-80-px"
          [ngClass]="{
            'color-dark-blue': workingHour.isAvailable && isEdit
          }"
        >
          {{ getDayName(i) }}
        </div>
        <app-toggle-switch
          [isChecked]="workingHour.isAvailable"
          (toggleChange)="toggleDay(i)"
          [ngClass]="{
            'disabled-opacity': !workingHour.isAvailable || !isEdit,
            'button-disabled': !isEdit
          }"
        ></app-toggle-switch>
        <div
          class="flex justify-content-between align-items-center"
          [ngClass]="{
            'disabled-opacity button-disabled': !workingHour.isAvailable || !isEdit
          }"
        >
          <app-dropdown
            class="margin-xxl--left-32"
            (selectedItemChange)="onWorkingHoursChange('startHour', i, $event)"
            [items]="timeOptions"
            [selectedItem]="selectedStartHours[i]"
            [icon]="'arrow'"
            [dropDownType]="DropDownTypeEnum.box"
          ></app-dropdown>
          <span class="font--xxl-12 margin-xxl--left-18 margin-xxl--right-18">To</span>
          <app-dropdown
            (selectedItemChange)="onWorkingHoursChange('endHour', i, $event)"
            [items]="timeOptions"
            [selectedItem]="selectedEndHours[i]"
            [icon]="'arrow'"
            [dropDownType]="DropDownTypeEnum.box"
          ></app-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>
